<template>
    <div class="printContainer grey">
        <div v-if="spiel" class="page" style="position: relative">
            <spiel-bericht-print-header :spiel="spiel" :liga="liga" title="Mannschaftsaufstellung">
            </spiel-bericht-print-header>
            <spiel-bericht-print-ma-l-team class="heim d-inline-block" :spiel="spiel"
                                            type="heim">
            </spiel-bericht-print-ma-l-team>
            <spiel-bericht-print-ma-l-team class="gast d-inline-block" :spiel="spiel"
                                            type="gast">
            </spiel-bericht-print-ma-l-team>
            <spiel-bericht-print-sign class="mt-2">
                SR-LV: {{spiel.referee.lvId}}
                <span class="px-4">SR-NR: {{spiel.referee.nr}}</span>
                Schiedsrichter/in:
                <span class="font-weight-bold">{{spiel.referee.name}}</span>
            </spiel-bericht-print-sign>
            <div class="heim d-inline-block bemerkungen mt-3 pa-1">Bemerkungen</div>
            <div class="gast d-inline-block bemerkungen mt-3 pa-1">Bemerkungen</div>
            <div style="font-size: 8px" class="mt-1">
                Die Sportkapitäne und Schiedsrichter sind einverstanden, dass Ihre Namen in Zusammenhang mit diesem Spiel auf
                der Webseite des ÖSKB veröffentlich werden.
            </div>
            <!-- navigation box -->
            <v-btn fab dark bottom right
                   color="primary" style="position: absolute; right: -80px; top: 15px; z-index: 15"
                   @click="openPrint()">
                <v-icon >mdi-printer</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { db } from '../../../../services/db'
    import {Spiel} from "../../../../services/data/spiel";
    import SpielBerichtPrintMaLTeam from "../print/spielBerichtPrintMaLTeam";
    import SpielBerichtPrintSign from "./spielBerichtPrint_Sign";
    import SpielBerichtPrintHeader from "./spielBerichtPrint_Header";
    export default {
        components: {
            SpielBerichtPrintHeader,
            SpielBerichtPrintSign,
            SpielBerichtPrintMaLTeam},
        name: "spiel-bericht-print-ma-l",
        data: () => ({
            spiel: null,
            landesverband: null,
        }),
        computed: {
            liga(){
                return this.spiel && this.landesverband ?
                    this.landesverband.ligen[this.spiel.getLigaId()].nameFull : '';
            }
        },
        created(){
            this.setSpiel();
            //window.print();
        },
        methods: {
            setSpiel(){
                db.collection("spiele").doc(this.$route.query.id).get()
                    .then((doc) => {
                    if (doc.exists) {
                        console.log("Document data:", doc.data());
                        this.spiel = new Spiel();
                        this.spiel.setFromDataObject(doc.data());
                        this.setLandesverband();
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            },
            setLandesverband(){
                db.collection("landesverbaende").doc(this.spiel.saison.lvId).get()
                    .then((doc) => {
                        if (doc.exists) {
                            console.log("Document data:", doc.data());
                            this.landesverband = doc.data();
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                        }
                    }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            },
            openPrint(){
                window.print()
            }
        },
    }
</script>

<style scoped>
    @media print{@page {size: portrait; margin: 0}}
    .heim { width: 49.5%; margin-right: 0.5% }
    .gast { width: 49.5%; margin-left: 0.5% }
    .bemerkungen {border: solid 1px black; font-size: 11px; height: 120px}
    /*https://codepen.io/rafaelcastrocouto/pen/LFAes*/
</style>